import { HStack, Heading, Text, Icon, VStack, Image, Stack } from '@chakra-ui/react';
import { IoTimerOutline } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';

import mealBoxReturn from '~/assets/images/mealBoxReturn.png';

export type MealBoxNoticeProps = {
  num: number;
};

export default function MealBoxNotice({ num }: MealBoxNoticeProps) {
  const navigate = useNavigate();

  return (
    <VStack bg="gray.100" borderRadius="5px" p={4} spacing={4} align="stretch">
      <Text textAlign="center" fontSize="sm" color="fontColor">
        待回收的餐具
      </Text>
      <Heading textAlign="center" fontSize="xl" letterSpacing={2}>
        {num}
      </Heading>

      <Stack align="stretch" direction={{ base: 'column', md: 'row' }} spacing={4}>
        <HStack
          flex="1"
          as="button"
          bg="white"
          px={2}
          justify="center"
          borderRadius="5px"
          boxShadow="0px 0px 10px rgba(0, 0, 0, 0.1)"
          spacing={2}
          onClick={() => navigate('/mealBoxRecycling/returnList')}
        >
          <HStack pos="relative" py={3}>
            <Image src={mealBoxReturn} pos="absolute" bottom={0} left={-20} />
            <Heading fontSize="md">我要歸還餐盒</Heading>
          </HStack>
        </HStack>

        <HStack
          flex="1"
          as="button"
          bg="primaryLight"
          py={3}
          justify="center"
          borderRadius="5px"
          spacing={2}
          onClick={() => navigate('/mealBoxRecycling/returnRecord')}
        >
          <Icon as={IoTimerOutline} color="white" boxSize="1.25rem" />
          <Heading color="white" fontSize="md">
            餐盒歸還紀錄
          </Heading>
        </HStack>
      </Stack>
    </VStack>
  );
}
